import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { APPROVER_ROLE_OPTIONS, dynamicApproverOption } from "../../constants"

export const approvalStepLabel = (step) => {
  if (!step) return "—"
  if (step.approverType === "role") {
    return APPROVER_ROLE_OPTIONS.find((o) => o.value === step.approverRef)?.label || step.approverRef
  }
  if (step.approverType === "emails") return step.approverRef
  const dynamic = dynamicApproverOption(step.approverType)
  if (dynamic) return dynamic.label
  return step.approverRef || step.approverType || "Approver"
}

// Compact "A → B → C" string, for the sticky Summary sidebar.
export const approvalRouteSummary = (approvalPreview) => {
  const steps = approvalPreview?.steps || []
  if (!approvalPreview) return null
  if (steps.length === 0) return "No approval required"
  return steps.map(approvalStepLabel).join(" → ")
}

// Full "Requester → Step → Step" vertical chain, used inside the form itself
// (both flows) — for a non-PO request this is the whole reason we show it up
// front, before any payee/bank fields.
const ApprovalRouteCard = ({ approvalPreview, loading }) => {
  const steps = approvalPreview?.steps || []

  return (
    <MDBox p={2} borderRadius="lg" bgColor="grey-100">
      {loading && !approvalPreview ? (
        <MDTypography variant="body2" color="text">
          Resolving the approval route…
        </MDTypography>
      ) : !approvalPreview ? (
        <MDTypography variant="body2" color="text">
          Approval route will be determined automatically based on the payment information and company approval policy.
        </MDTypography>
      ) : steps.length === 0 ? (
        <MDTypography variant="body2" color="text">
          No approval required for this amount — goes straight to accounting.
        </MDTypography>
      ) : (
        <MDBox display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
          <MDTypography variant="button" fontWeight="medium">
            Requester
          </MDTypography>
          {steps.map((step, idx) => (
            <MDBox key={idx} display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
              <Icon fontSize="small" color="secondary">
                arrow_downward
              </Icon>
              <MDBox display="flex" alignItems="center" gap={1}>
                <MDTypography variant="button" fontWeight="medium">
                  {approvalStepLabel(step)}
                </MDTypography>
                <MDTypography variant="caption" color="text">
                  ({step.mode === "parallel" ? "all at once" : "one at a time"})
                </MDTypography>
              </MDBox>
            </MDBox>
          ))}
        </MDBox>
      )}
    </MDBox>
  )
}

export default ApprovalRouteCard
